import { InstrumentBookFullDto } from '@/gen/marketDataApi'

import { Card } from '@/components/card'
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/table/index.tsx'

import DepthPricePoints from './depthPricePoints.tsx'

interface Props {
    asks: Array<InstrumentBookFullDto['asks'][0] & { quantity: number }>
    largestQuantity: number
    otherSideCount: number
}

export default function Asks({ asks, largestQuantity, otherSideCount }: Props) {
    return (
        <Card hideOverflow>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead>Offer</TableHead>
                        <TableHead>Quantity</TableHead>
                        <TableHead>Orders</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    <DepthPricePoints
                        bidOrAsk="ask"
                        points={asks}
                        largestQuantity={largestQuantity}
                        otherSideCount={otherSideCount}
                    />
                </TableBody>
            </Table>
        </Card>
    )
}
